import React from "react";
import styled from "styled-components";
import { HEADER_HEIGHT } from "../../constants";

const Wrapper = styled.header`
  height: ${HEADER_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-family: monospace;
  width: fit-content;
  line-height: 1;
  margin: 0 auto;
  text-align: center;
  @media (min-width: 600px) {
    font-size: 3rem;
  }
  @media (min-width: 768px) {
    font-size: 4rem;
  }
`;
const TitleLink = styled.a`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

function Header() {
  return (
    <Wrapper>
      <TitleLink href="/">
        <Title>Smile Like Zuck</Title>
      </TitleLink>
    </Wrapper>
  );
}

export default Header;
